module.exports = __webpack_public_path__ + "img/applyVip.6bf730f5.png";